import { ICustomer } from '../../../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(customer?: ICustomer): Record<string, any> {
  return {
    customer_status: customer?.email ? 'Returning' : 'Guest',
  };
}
